module.exports = __webpack_public_path__ + "img/auto_texts_active.78be3305.svg";